import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/application/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/opt/atlassian/pipelines/agent/build/application/node_modules/swr/dist/index/config-12s-Bi4rgVRk.mjs");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/Ad/slots/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/AstronomyBox/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/common/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/[product]/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["BackToForecastCTA"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/BackToForecastCTA/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ClientOnly/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/CurrentWeather/simple.styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/ErrorBoundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SummaryWithSpacesItem"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastDetails/daysWithSpaces/summaryWithSpacesItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShowMore"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastDetails/hoursShowMore.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastDetails/items/itemHour.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ItemSpace"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastDetails/items/itemSpace.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ItemSummary"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastDetails/items/itemSummary.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastDetails/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastNavigation/top.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TopItem"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastNavigation/topItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ForecastTabsInner"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/ForecastTabs/ForecastTabsInner.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/LoadingSkeleton/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SkiAreaLinkItem"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/LocationTiles/skiAreaLinkItem.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/LocationTiles/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/Slider/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/components/SunHoursText/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Web2App"] */ "/opt/atlassian/pipelines/agent/build/application/src/components/Web2App/index.tsx");
